export default {
  setConfigs(state, data) {
    state.configs = data;
  },

  setCamping(state, data) {
    state.camping = data;
  },

  setUrlToCV(state, data) {
    state.urlToPrenotazioneCV = data;
  },
};
